// extracted by mini-css-extract-plugin
export default {"button":"button---mtWnz","button__inner":"button__inner---QdDAh","button__label":"button__label---Y_nu2","button__label__inner":"button__label__inner---vjzEf"};